import { render, staticRenderFns } from "./CompMarkdownText.vue?vue&type=template&id=7a600906&"
import script from "./CompMarkdownText.vue?vue&type=script&lang=ts&"
export * from "./CompMarkdownText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports